/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import { ModelInput, IModelInputBaseConfig } from "../ModelInput";
import { TValidatonError, VALIDATION_ERROR_TYPE } from "../IValidationError";

export interface IInputTextConfig extends IModelInputBaseConfig {}

/**
 * Input for text value
 */
export class ModelInputText extends ModelInput<string, string, IInputTextConfig> {

	protected parse(newValue) {

		return newValue;

	}

	protected validate(inputValue: string, value: string): Array<TValidatonError> {

		// Check required
		if (this.config.required === true && inputValue.trim() === "") {
			return [{
				type: VALIDATION_ERROR_TYPE.REQUIRED,
				message: "Value is required."
			} as TValidatonError];
		}

		// Skip if not required and empty
		if (inputValue.trim() === "") {
			return [];
		}

		return [];

	}

}

/**
 * Text field
 *
 * @param opts Options
 */
export function inputText(opts: IInputTextConfig) {

	return (handler) =>
		new ModelInputText(handler, "text", "", opts);

}
